export default "__VITE_ASSET__DFEujOjc__"